import { render } from "./EscalatedClientPosts.vue?vue&type=template&id=61bb0370&ts=true"
import script from "./EscalatedClientPosts.vue?vue&type=script&lang=ts"
export * from "./EscalatedClientPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__